import React from 'react';
import { Field } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';
import { Form, Col, Card } from 'react-bootstrap';

import { campotexto, camposelect } from '../campos/campos';
import { getTraducaoTrocaPor as trad, getCampoTraducao as tradCampo } from '../../../utils/getTraducoes';
import { getDadosToOptions } from '../utils/toolsforms';

class FormInscricao extends React.Component {

  state = {
    especificacargo: false,
    cart:JSON.parse(localStorage.getItem('cart'))
  }
  componentDidMount() {
    //mount
  }

  handleCargos = (cargos) => {
    let result = getDadosToOptions(cargos, 'idcargo', trad, this.props.trads, tradCampo(this.props.lingua), 'SELECIONE');
    return result;
  }

  handleCargoEspecificar = (value) => {
    const cargo = this.props.dadoscargos.filter(itens => (itens.idcargo === parseInt(value)));
    this.setState({
      especificacargo: cargo[0].outros === 'S'
    })
  }


  render() {
    const trads = this.props.trads;
    const lingua = this.props.lingua;
    const required = value => (value ? undefined : trad(trads, 'JSOBRIGATORIO', lingua));
    let participantes = this.state.cart.products.map(product => {
      let conteudo = [];
      for (let i = 1; i <= product.qt; i++) {
        conteudo.push(<Card key={i} className='mb-3'>
          <Card.Header><Card.Title>{product.product[tradCampo(lingua)]+" nº "+i}</Card.Title></Card.Header>
          <Card.Body>
            <Form.Row>
              <Form.Group as={Col} md="6" controlId="email" style={this.props.styles['email'] ? this.props.styles['email'] : {}}>
                <Field type='tel'
                  styles={this.props.styles}
                  placeholder={trad(trads, 'EMAIL', lingua)}
                  label={trad(trads, 'EMAIL', lingua)}
                  name='email' component={campotexto} />
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="cpf" style={this.props.styles['cpf'] ? this.props.styles['cpf'] : {}}>
                <Field type='tel'
                  styles={this.props.styles}
                  placeholder={trad(trads, 'TITLECPF', lingua)}
                  label={trad(trads, 'TITLECPF', lingua)}
                  name='cpf' component={campotexto} />
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} md="6" controlId="nome" style={this.props.styles['nome'] ? this.props.styles['nome'] : {}}>
                <Field type='text'
                  styles={this.props.styles}
                  placeholder={trad(trads, 'TITLENOME', lingua)}
                  label={trad(trads, 'TITLENOME', lingua)}
                  name='nome'
                  component={campotexto} />
                <OnChange name="nome">
                  {this.handleNome}
                </OnChange>
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="sobrenome" style={this.props.styles['sobrenome'] ? this.props.styles['sobrenome'] : {}}>
                <Field type='text'
                  styles={this.props.styles}
                  placeholder={trad(trads, 'TITLESOBRENOME', lingua)}
                  label={trad(trads, 'TITLESOBRENOME', lingua)}
                  name='sobrenome'
                  component={campotexto} />
                <OnChange name="sobrenome">
                  {this.handleSobrenome}
                </OnChange>
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} md="4" controlId="EMPRESA" style={this.props.styles['empresa'] ? this.props.styles['empresa'] : {}}>
                <Field type='text'
                  styles={this.props.styles}
                  placeholder={trad(trads, 'EMPRESA', lingua)}
                  label={trad(trads, 'EMPRESA', lingua)} name='empresa' component={campotexto} />
              </Form.Group>
              <Form.Group as={Col} md="4" controlId="idcargo" style={this.props.styles['idcargo'] ? this.props.styles['idcargo'] : {}}>
                <Field
                  styles={this.props.styles}
                  placeholder={trad(trads, 'CARGO', lingua)}
                  options={
                    this.handleCargos(this.props.dadoscargos)
                  }
                  label={trad(trads, 'CARGO', lingua)} name='idcargo' component={camposelect} />
                <OnChange name='idcargo'>
                  {this.handleCargoEspecificar}
                </OnChange>
              </Form.Group>
              {this.state.especificacargo ?
                <Form.Group as={Col} md="4" controlId="outroscargo" style={this.props.styles['outroscargo'] ? this.props.styles['outroscargo'] : {}}>
                  <Field type='text'
                    required={required}
                    styles={this.props.styles}
                    placeholder={trad(trads, 'ESPECIFIQUE', lingua)}
                    label={trad(trads, 'ESPECIFIQUE', lingua)} name='outroscargo' component={campotexto} />
                </Form.Group>
                :
                null
              }
              <Form.Group as={Col} md="4" controlId="cargocredencial" style={this.props.styles['cargocredencial'] ? this.props.styles['cargocredencial'] : {}}>
                <Field type='text'
                  styles={this.props.styles}
                  placeholder={trad(trads, 'CARGO_CREDENCIAL', lingua)}
                  label={trad(trads, 'CARGO_CREDENCIAL', lingua)} name='cargocredencial' component={campotexto} />
              </Form.Group>
            </Form.Row>
          </Card.Body>
        </Card>);
      }
      return conteudo;
    });
    return (
      <>
        {participantes}
      </>
    );
  }
}

export default FormInscricao;